import { sipEngine } from "./SipEngine";
import type { WebphoneCredentials } from "../types";

export function hasWebphoneCredentials(info: WebphoneCredentials | null | undefined): boolean {
  if (!info?.sip_username || !info?.sip_password) return false;
  return Boolean(info.webphone_wss_url || info.webphone_ast_host);
}

export function startWebphone(userInfo: WebphoneCredentials) {
  if (!hasWebphoneCredentials(userInfo)) {
    console.error("Missing required webphone credentials");
    return false;
  }

  sipEngine.setparameter("serveraddress", userInfo.webphone_ast_host || "");
  sipEngine.setparameter("username", userInfo.sip_username);
  sipEngine.setparameter("password", userInfo.sip_password);
  sipEngine.setparameter("techprefix", userInfo.prefix || "");
  if (userInfo.webphone_wss_url) {
    sipEngine.setparameter("webphone_wss_url", userInfo.webphone_wss_url);
  }
  if (userInfo.ice_servers) {
    sipEngine.setparameter("ice_servers", JSON.stringify(userInfo.ice_servers));
  }
  sipEngine.setparameter("autoaccept", userInfo.auto_pickup ? "1" : "0");
  sipEngine.setparameter("autopickup", userInfo.auto_pickup ? "1" : "0");

  void (async () => {
    await sipEngine.start();
    await sipEngine.register();
    sipEngine.setvolume(0, 100);
  })();

  return true;
}

export async function stopWebphone() {
  try {
    await sipEngine.hangup();
    await sipEngine.unregister();
    await sipEngine.stop();
  } catch (err) {
    console.error("Failed to stop webphone", err);
  }
}

export function makeCall(destination: string, lineId?: number) {
  if (!destination.trim()) return;
  void sipEngine.call(destination.trim(), lineId);
}

export function acceptCall(lineId?: number) {
  void sipEngine.accept(lineId);
}

export function rejectCall(lineId?: number) {
  void sipEngine.reject(lineId);
}

export function hangupCall(lineId?: number) {
  void sipEngine.hangup(lineId);
}

export function setHold(hold: boolean, lineId?: number) {
  void sipEngine.hold(hold, lineId);
}

export function setMute(muted: boolean) {
  sipEngine.mute(muted);
}

export function sendDtmf(digit: string | number) {
  sipEngine.dtmf(digit);
}

export function setSpeaker(on: boolean) {
  sipEngine.setSpeaker(on);
}
